export const colFormRef = 'col-form-change-password';
